module.exports = __webpack_public_path__ + "static/media/throne_room.5dafe171.jpg";